import { render, staticRenderFns } from "./batchCard.vue?vue&type=template&id=1c21c738&"
import script from "./batchCard.vue?vue&type=script&lang=js&"
export * from "./batchCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports